import { useState, useEffect } from 'react';

import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';

import { getDataCard } from '@shared/services/services';

import BookingPriceDetails from '../../helpers/BookingPriceDetails';

import CardPaymentDetails from './CardPaymentDetails';

const BookingPurchaseSummary = ({
  paymentResult,
  transactionId,
  price,
  pagos,
  cardData,
}) => {
  const theme = useTheme();

  const [loadingCard, setLoadingCard] = useState(false);
  const [dataCard, setDataCard] = useState({ listPyaments: [] });

  const fetchDataCard = async () => {
    setLoadingCard(true);
    try {
      const result = await getDataCard({
        transaction_list: [transactionId],
      });
      setDataCard(result);
    } catch (e) {
      console.error('Error Card', e);
    } finally {
      setLoadingCard(false);
    }
  };

  useEffect(() => {
    if (paymentResult && transactionId) {
      fetchDataCard();
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const details = pagos ? price.details : price.details_USD;
  const isInUSD = !pagos;

  return (
    <Box id="BOX-BOOKING-PURCHASE-SUMMARY">
      <BookingPriceDetails
        details={details}
        showTitle
        isInUSD={isInUSD}
        cardData={cardData}
        currencyValue={pagos ? price?.currency_value : null}
        chargesMessage={Number(details?.charges) === 0}
      />
      {paymentResult && pagos && (
        <Grid
          container
          sx={{
            pt: { xs: '20px', sm: '30px' },
            pb: { xs: '20px', sm: 0 },
          }}
        >
          <Typography
            sx={{
              color: '#000',
              fontWeight: 600,
              fontSize: { xs: '16px', sm: '20px' },
              pb: { xs: '5px', sm: '10px' },
              lineHeight: 1,
            }}
          >
            Datos de tarjeta
          </Typography>

          <Typography
            sx={{
              color: '#000',
              fontSize: { xs: '14px', sm: '16px' },
            }}
          >
            {loadingCard ? (
              <CircularProgress size={25} sx={{ color: theme.text1 }} />
            ) : (
              <CardPaymentDetails dataCard={dataCard} />
            )}
          </Typography>
        </Grid>
      )}
    </Box>
  );
};
export default BookingPurchaseSummary;
